const getFlashType = function (message_type) {
  switch (message_type) {
    case "notice":
      return "success";
    case "alert":
      return "error";
    case "warning":
      return "warning";
    default:
      return "success";
  }
};

export default getFlashType;
